const urlRoot = '/delay-repay';

export const URL = {
    getFavouriteJourneys: `${urlRoot}/favourite-journey/customer/{id}/journeys`,
    saveFavouriteJourney: `${urlRoot}/favourite-journey/customer/{id}`,
    deleteFavouriteJourney: `${urlRoot}/favourite-journey/customer/{userId}/journeys/{journeyId}`,
    editFavouriteJourney: `${urlRoot}/favourite-journey/customer/{userId}/journeys/{journeyId}`,
};
